<template>
    <nav 
        :class="{'nav-home': $route.name == 'home', 'bg-blue': simpleNav }"
        class="navbar navbar-expand-lg layout-navbar navbar__inner-page js-main-nav" 
    >
        <div class="container max-width-lg">
            <!-- Brand Logo -->
            <router-link to="/"
                class="navbar-brand animated slideInLeft" duration="5000">
                <img v-if="$route.name == 'home' || simpleNav" src="../../assets/images/logo-torbel-white.svg" alt="Logo Torbel">
                <img v-else src="../../assets/images/logo-torbel-narvbar-fix.svg" alt="Logo Torbel">
            </router-link>
            

            <!-- Navbar Mobile Button -->            
            <button
                class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation">
                <i class="fas fa-bars"></i>
            </button>
        
            <!-- Navbar Desktop -->
            <div id="navbarSupportedContent" class="collapse navbar-collapse justify-content-end animated slideInDown" duration="3000">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <router-link 
                            class="nav-link" 
                            :to="{ name: 'home'}">
                            Inicio<span class="sr-only">(current)</span>
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link 
                            v-on:click.native="closeMenu"
                            :to="{ name: 'empresa'}"
                            class="nav-link" 
                        >
                            La empresa
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link 
                            v-on:click.native="closeMenu"
                            :to="{ name: 'proyectos'}"
                            class="nav-link" 
                        >
                            Proyectos
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link 
                            v-on:click.native="closeMenu"
                            :to="{ name: 'linea-servicio'}"
                            class="nav-link" 
                        >
                            Línea de servicios
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link 
                            v-on:click.native="closeMenu"
                            :to="{ name: 'clientes'}"
                            class="nav-link" 
                        >
                            Clientes
                        </router-link>
                    </li>
                </ul>
            </div>

            <div class="btn-contact social__navbar">
                <!-- <a 
                    href="https://api.whatsapp.com/send?phone=18297623396&text=Para consultas y solicitudes, contáctanos." 
                    target="_blank" 
                    class="btn" 
                    :class="$route.name == 'home' ? 'btn-outline-light' : 'btn-outline__blue'">
                    Contáctanos
                </a> -->
                <a href="https://www.facebook.com/Torbel-SRL-1781222338771029/" target="_blank">
                    <i class="icon fab fa-facebook-square social__navbar-icon"></i>
                </a>
                <a href="https://www.instagram.com/torbelrd/" target="_blank">
                    <i class="icon fab fa-instagram social__navbar-icon"></i>
                </a>
            </div>
        </div>
    </nav>
</template>
<script>
import $ from "jquery";
export default {
    props: {
        simpleNav: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            navFixed : 'nav-fixed',
        };
    },
    mounted() {
        $("body").click((e) => {
            if(!($(e.target).parents('.js-main-nav').length || $(e.target).hasClass("js-main-nav")) && $(".collapse.show").length) {
                e.preventDefault();
                this.closeMenu();
            }
        })
    },
    methods: {
        closeMenu() {
            document.getElementById("navbarSupportedContent").classList.remove("show");
        }
    }
};
</script>

<style lang="scss">
.navbar {
    position: relative!important;
    width:100%;
    height: 100%;
    max-height: 150px;
    z-index:1;

    .social__navbar {
        .social__navbar-icon {
            font-size: $content-font-size;
            color: $primary-color;
            margin:0 5px;
        }
    }

    .container {
        justify-content: flex-end;
    }
}

.btn-contact {
    order: 1;
    @media (min-width: 992px) {
        order: 4;
    }
    @media (max-width: 574px) {
        display: none;
    }
}
.nav-home {
    .social__navbar {
        .social__navbar-icon {
            font-size: $content-font-size;
            color: $white;
            margin:0 5px;
        }
    }
}


.navbar-collapse {
    order: 3;

    @media (max-width: 991px) {     
        margin: 0 -16px;
        animation: none;
    }
} 

.navbar-toggler {
    color: $white;
    margin-left: 10px;
    order: 2;
}

.navbar:not(.nav-home) {
    .navbar-toggler {
        color: $primary-color;
    }

    .navbar-collapse {
        @media (max-width: 991px) {      
            background-color: white;
        }
    }
}

.navbar-brand {
    flex: 1;
    order: 0;
    img {
        width: 363px; // +21% from original (10% more than 330px)
    }
}
.navbar-nav {
    .nav-item {
        margin-right: 15px;

        a {
            color: $primary-color;
            font-size:$extra-small-font-size;

            &.router-link-exact-active {
                border-bottom:1px solid $primary-color;
                @media (max-width: 991px) {
                    font-weight: bold;
                    border: none;
                }
            }

            &:hover {
                border-bottom:1px solid $primary-color;
                @media (max-width: 991px) {
                    font-weight: bold;
                    border: none;
                }
            }
        }
    }
    @media (max-width: 991px) {
        padding: 16px !important;
    }
}

// .navbar {
//     transition: top .5s;
//     top: -50%;
// }


.scrolled .nav-home.nav-home,
.scrolled .navbar:not(.nav-home) {
    position: sticky !important;
    top: 0%;
    max-height: 150px;
    z-index: 999;
    box-shadow: 0 0 10px 0 rgba(141, 94, 94, 0.08);
}

.bg-blue {
    background-color: $bg-blue;
}

.scrolled .nav-home {
    background: $bg-blue;
    .navbar-toggler  {
        color: $white;
    }
    .navbar-collapse {
        background-color: $bg-blue;
    }
}
.scrolled .navbar:not(.nav-home) {
    background: $white;
}

</style>